import { render } from "./TriviaInfo.vue?vue&type=template&id=615aa727&scoped=true"
import script from "./TriviaInfo.vue?vue&type=script&lang=js"
export * from "./TriviaInfo.vue?vue&type=script&lang=js"

import "./TriviaInfo.vue?vue&type=style&index=0&id=615aa727&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615aa727"]])

export default __exports__